import { PureComponent } from 'react';

const STYLE_TAG_ID = 'hover-react-style-override';

export default class StyleOverrides extends PureComponent {
  componentDidMount() {
    this.styleTag = this.findOrCreateStyleTag();
    this.styleTag.innerHTML = this.getStyles(false);
  }

  componentWillUnmount() {
    this.styleTag.innerHTML = this.getStyles(true);
  }

  render() {
    return null;
  }

  findOrCreateStyleTag() {
    let styleTag = document.getElementById(STYLE_TAG_ID);
    if (styleTag) return styleTag;

    styleTag = document.createElement('style');
    styleTag.id = STYLE_TAG_ID;
    styleTag.type = 'text/css';
    const head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(styleTag);
    return styleTag;
  }

  getStyles(show = false) {
    return `
      section.main-section {
        ${
          '' /* we remove this transform and add a margin to the top, otherwise  position fixed won't work properly on mobile */
        }
        transform: ${show ? 'inherit' : 'none !important'};
      }
      #ui-view-container {
        padding-bottom: ${show ? '60px' : '0px'};
      }
      @media print {
        hov-header {
          display: none;
        }
        #react-root * {
          max-width: 100vw !important;
        }
      }
    `;
  }
}
